export default "__VITE_ASSET__Cpz8ZP2U__"